<ul class="container">
  <h3 class="title">{{ titleModal }}</h3>
  <div class="body">
    <form [formGroup]="formMoreInformation" class="more-information-group">
      <div class="form-control">
        <app-input
          class="input-control"
          id="condominium_value"
          [label]="'Valor do condomínio'"
          maxlength="14"
          [iconPathAlt]="{ path: 'reais', alt: 'reais' }"
          formControlName="condominium_value"
          [messageError]="'Valor do condomínio requerido'"
          [isPrice]="true"
          [placeholder]="'Ex: 700,00'"
        >
        </app-input>
        <app-input
          class="input-control"
          id="iptu_value"
          [label]="'IPTU (R$/mês)'"
          maxlength="14"
          [iconPathAlt]="{ path: 'reais', alt: 'reais' }"
          formControlName="iptu_value"
          [messageError]="'IPTU requerido'"
          [isPrice]="true"
          [placeholder]="'Ex: 800,00'"
        >
        </app-input>
        <lib-input-checkbox
          class="input-control check"
          [id]="'iptu_free'"
          formControlName="iptu_free"
          name="iptu_free"
          (click)="validationIptu()"
          label="IPTU Isento"
        ></lib-input-checkbox>
      </div>
      <div class="form-control">
        <div class="input-control type-keys">
          <span>Tipos de chave</span>
          <app-multi-selection-tags
            [disabled]="false"
            value="value"
            [options]="options"
            [tags]="tags"
            (changed)="setTags($event)"
          ></app-multi-selection-tags>
        </div>
        <app-input
          class="input-control"
          id="keys_location"
          [label]="'Localização das chaves'"
          maxlength="100"
          formControlName="keys_location"
          [messageError]="'Localização das chaves requerido'"
          [placeholder]="'Ex: Com o porteiro'"
        >
        </app-input>
      </div>
    </form>
    <hr class="line" />
    <p class="bold">Valor do pacote</p>
    <p class="desc">
      A soma dos valores de aluguel, condomínio e mensalidade do IPTU
    </p>
    <p class="value">R$ 4000,00</p>
  </div>
</ul>
